import React from 'react';
import noop from 'lodash/noop';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import Badge from '@atlaskit/badge';
import Button from '@atlaskit/button';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../../messages.tsx';
import { LoadingStateAnimationWrapper } from '../loading-state/styled.tsx';
import {
	Container as LabelContainer,
	StyledBadge,
	StyledLabel,
} from '../picker-trigger/trigger-component-no-operator/main.tsx';

const AddFilterFallback = ({ optionalFieldsCount }: { optionalFieldsCount: number }) => {
	const { formatMessage } = useIntl();

	/**
	 * We only show `More` button with loading state when there's more than 1
	 * optional field with selected values underneath.
	 * Otherwise we display the default `More` button
	 */

	if (optionalFieldsCount > 0) {
		return (
			<LoadingStateAnimationWrapper>
				<Button
					appearance="default"
					isSelected
					onClick={noop}
					label="addButton"
					testId="jql-builder-basic.common.ui.add-filter-fallback.loading"
				>
					<LabelContainer>
						<StyledLabel>{formatMessage(messages.moreButton)}</StyledLabel>
						<StyledBadge>
							<Badge appearance="primary">{`+${optionalFieldsCount}`}</Badge>
						</StyledBadge>
					</LabelContainer>
				</Button>
			</LoadingStateAnimationWrapper>
		);
	}

	return (
		<Button
			appearance="default"
			iconAfter={<ChevronDownIcon label="" color="currentColor" size="small" />}
			isSelected={false}
			onClick={noop}
			label="addButton"
			testId="jql-builder-basic.common.ui.add-filter-fallback.loading"
		>
			{formatMessage(messages.moreButton)}
		</Button>
	);
};

export default AddFilterFallback;
